import { STICKY_GROUP_ROW_HEIGHT } from '../../virtualizedTable.styles';
import { VIRTUALIZED_TABLE_ID } from '../../virtualizedTableIds';

const TABLE_SELECTOR = `table[id="${VIRTUALIZED_TABLE_ID}"]`;
const ROW_ID_ATTRIBUTE = 'data-row-id';
const ROW_SELECTOR = `tbody tr[${ROW_ID_ATTRIBUTE}]`;

export const findStickyGroupTable = (overlay: HTMLElement): HTMLElement | null => {
  let ancestor = overlay.parentElement;

  while (ancestor) {
    const table = ancestor.querySelector<HTMLElement>(TABLE_SELECTOR);

    if (table) {
      return table;
    }

    ancestor = ancestor.parentElement;
  }

  return null;
};

export const collectRowTops = (table: HTMLElement): Map<string, number> => {
  const rowTops = new Map<string, number>();

  table.querySelectorAll(ROW_SELECTOR).forEach((row) => {
    rowTops.set(row.getAttribute(ROW_ID_ATTRIBUTE) ?? '', row.getBoundingClientRect().top);
  });

  return rowTops;
};

export const measureBandHeight = (overlay: HTMLElement): number => {
  const band = overlay.firstElementChild?.querySelector('table');

  return band ? Math.round(band.getBoundingClientRect().height) : STICKY_GROUP_ROW_HEIGHT;
};
